import React from "react"
import styled from "react-emotion"

import { Text, Section } from "ui"

const Label = styled(Text)`
    font-weight: 100;
    font-size: 0.8em;
    margin: 0px;
    margin-bottom: -8px;
    padding: 0px;
    letter-spacing: 1px;
    color: #777;
`

const AttributeWrapper = styled(Section)`
    margin: 8px;
    flex-basis: 250px;
    max-width: 250px;

    ${props =>
        !props.dontHideOverflow &&
        `
        overflow: hidden;
        
        & > * {
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    & > * > p {
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
    }`};
`

const LabelledAttribute = props => (
    <AttributeWrapper dontHideOverflow={props.dontHideOverflow}>
        <Label>{props.label}</Label>
        <Text margin="none">{props.children}</Text>
    </AttributeWrapper>
)

export default LabelledAttribute



// WEBPACK FOOTER //
// ./src/ui/components/LabelledAttribute.js